import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f4280ed"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "spot" }
const _hoisted_2 = { class: "spot-inner" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "circle" }, null, -1))
const _hoisted_4 = { class: "icon" }

import { PropType, computed } from 'vue'
import { Hotspot, useMiniMapHotspots } from '@/services/stores/hotspots'
import { useGameState } from '@/services/composition';


export default /*#__PURE__*/_defineComponent({
  props: {
  hotspot: {
    type: Object as PropType<Hotspot>,
    required: true
  },
  isSelected: {
    type: Boolean,
    default: false
  }
},
  emits: ["change"],
  setup(__props, { emit }: { emit: ({
  (e: 'change', id: number): void
}), expose: any, slots: any, attrs: any }) {

const props = __props

const { findHotspot: findMapHotspot } = useMiniMapHotspots()
const state = useGameState()



const position = computed(() => {
  return findMapHotspot(props.hotspot.id)?.position || [0, 0]
})

const transform = computed(() => {
  return { left: `${position.value[0] * 100}%`, top: `${position.value[1] * 100}%` }
})

const hotspotClass = computed(() => {
  return {
    selected: props.isSelected,
    fail: hasDoneBad.value,
    success: hasDoneRight.value
  }
})

const isExit = computed(() => {
  return state.value.matches('tuto.xr.exit_room') || state.value.matches('game.bedroom.exit_room') || state.value.matches('game.corridor.exit_room') || state.value.matches('game.studyroom.exit_room') || state.value.matches('game.living.exit_room')
})

const isDone = computed(() => {
  return state.value.context.hotspots.includes(props.hotspot.id) || isExit.value
})

const hasDoneRight = computed(() => {
  return isDone.value && props.hotspot.points > 0
})

const hasDoneBad = computed(() => {
  return isDone.value && props.hotspot.points < 0
})


const handleClick = () => {
  emit('change', props.hotspot.id)
}

return (_ctx: any,_cache: any) => {
  const _component_ui_icon = _resolveComponent("ui-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass(["map-hotspot", _unref(hotspotClass)]),
      style: _normalizeStyle(_unref(transform)),
      onClick: handleClick
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_ui_icon, {
              name: __props.hotspot.icon
            }, null, 8, ["name"])
          ])
        ])
      ])
    ], 6)
  ]))
}
}

})